import React from 'react';

import { Paper } from '@mui/material';

import ForgotPassword from './ForgotPassword';
import SignIn from './SignIn';
import SignUp from './SignUp';
import SignUpConfirm from './SignUpConfirm';
import VerifyEmail from './VerifyEmail';

import type { ModeAuthType, UserType } from '@/types/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType | undefined,
  /** モード */
  mode: ModeAuthType | undefined,
}

const Authenticator: React.FC<Props> = ({ user, mode }) => {
  let comp = null;
  if (mode === 'loading') {
    return null;
  }
  if (mode === 'signin') {
    comp = <SignIn />;
  } else if (mode === 'signup') {
    comp = <SignUp />;
  } else if (mode === 'confirmsignup') {
    if (user) {
      comp = <SignUpConfirm user={user} />;
    }
  } else if (mode === 'verifyemail') {
    if (user) {
      comp = <VerifyEmail user={user} />;
    }
  } else if (mode === 'forgotpassword') {
    comp = <ForgotPassword isSubmit={false} user={user} />;
  } else if (mode === 'forgotpasswordsubmit') {
    comp = <ForgotPassword isSubmit user={user} />;
  }
  return (
    <Paper
      style={{
        padding: '16px 16px 8px',
        margin: '20px auto',
        maxWidth: '500px',
      }}
    >
      {comp}
    </Paper>
  );
};

export default Authenticator;
